import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-five',
  templateUrl: './header-five.component.html',
  styleUrls: ['./header-five.component.css']
})
export class HeaderFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
